import * as React from 'react';

import { IDocument, IBranding } from '../../infrastructure/interfaces';
import CheckBox from '../CheckBox';

export interface IBrandingListEditorFormProps {
  document: IDocument;
  brandingsList: IBranding[];
  onBrandChange(brand: IBranding): void;
  className: string;
}

export default class BrandingListEditorForm extends React.Component<IBrandingListEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.brandingsList.filter(b => b.title !== 'Nutrien Wholesale').map((brand) => {
          const document = this.props.document;
          const disabled = document.brandings.length >= 2 && document.brandings.findIndex(l => l.id === brand.id) === -1;
          const checked = document.brandings.findIndex(l => l.id === brand.id) > -1;
          return (<div className="brandingsList-stepRow" key={brand.id}>
            <CheckBox
              onClick={() => this.props.onBrandChange(brand)}
              checked={checked}
              disabled={disabled} />
            <img
              className="logoImage"
              src={brand.image}
              alt={brand.title}
            />
          </div>);
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/BrandingListEditorForm.tsx